
define('jst!lib/paginated_collection/_nav',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="pagination-nav">\n  <a href="#" class="show-more"><%= t(\'Show {0} more #pagination\').format(pageSize) %></a>\n</div>');
 });

